/**
 * Google Cloud Armor (and similar edge proxies) may return 429 with an HTML body.
 * Call {@link throwIfRateLimited} before `response.json()` so callers never parse HTML as JSON.
 */
export const MCC_TOO_MANY_REQUESTS_MESSAGE =
  'Too many requests were sent from your connection. Please wait about five minutes, then try again. If this keeps happening, contact support.';

export function throwIfRateLimited(response: Response): void {
  if (response.status === 429) {
    throw new Error(MCC_TOO_MANY_REQUESTS_MESSAGE);
  }
}
